import { mapState } from 'pinia';
import { useAdminProjectContextStore } from '@/Stores/Admin/projectContextStore';
import { useProjectAdditionalInfoStore } from '@/Stores/Admin/projectAdditionalInfoStore';

const latePledgeNotificationDescription = 'Your project is currently in the late pledge stage. You can edit these settings, but they will have their effect and be available to backers after the pledge manager is open.';
const pledgeManagerCompleteNotificationDescription = 'Your project is currently in the pledge manager (closed) stage. You can edit these settings, but changes will not affect backers unless the pledge manager is reopened.';

export default {
    computed: {
        projectLimitationsSettingsMessage() {
            return this.isPledgeManagerComplete
                ? pledgeManagerCompleteNotificationDescription
                : this.isInLatePledgeOrEnded
                    ? latePledgeNotificationDescription
                    : null;
        },
        projectLimitationsLocationSettingsMessage() {
            return this.taxHandlingEnabled
                ? null
                : this.projectLimitationsSettingsMessage;
        },
        projectLimitationsShippingSettingsMessage() {
            return this.earlyShippingCollectionEnabled
                ? null
                : this.projectLimitationsSettingsMessage;
        },
        taxHandlingEnabled() {
            return this.projectAdditionalInfo?.enableTaxHandling;
        },
        earlyShippingCollectionEnabled() {
            return this.projectAdditionalInfo?.earlyShippingCollectionEnabled;
        },
        isInLatePledgeOrEnded() {
            return this.isLatePledge || this.isLatePledgeEnded;
        },
        ...mapState(useAdminProjectContextStore, ['isLatePledge', 'isLatePledgeEnded', 'isPledgeManagerComplete']),
        ...mapState(useProjectAdditionalInfoStore, ['projectAdditionalInfo']),
    },
};